import { toast } from "react-toastify";
import { Template } from "types/landlord/verificationTemplate";
import {
  dataURLtoFile,
  getPresignedUrl,
  uploadFileToS3Bucket
} from "utils/fileHandlers";

import { createAssetRecord } from "utils/fileHandlers";

const uploadSignatureFile = async (file: File) => {
  try {
    const presignedUrl = await getPresignedUrl(file);
    const { url } = await uploadFileToS3Bucket(presignedUrl, file);
    const globalId = await createAssetRecord(url, file);
    return globalId;
  } catch (error) {
    toast.error(`Error uploading signature file: ${error}`);
    throw error;
  }
};

export const uploadTemplateSignature = async (template: Template) => {
  const { svg, png } = template.adverse_action_letter_signature || {};
  if (
    typeof svg === "string" &&
    typeof png === "string" &&
    svg.includes("data:image/svg+xml") &&
    png.includes("data:image/png")
  ) {
    const svgFile = svg ? dataURLtoFile(svg, "signature.svg") : null;
    const pngFile = png ? dataURLtoFile(png, "signature.png") : null;

    try {
      const [svgGlobalId, pngGlobalId] = await Promise.all([
        svgFile ? uploadSignatureFile(svgFile) : Promise.resolve(null),
        pngFile ? uploadSignatureFile(pngFile) : Promise.resolve(null)
      ]);
      if (svgGlobalId && pngGlobalId)
        return {
          ...template,
          adverse_action_letter_signature: {
            svg: svgGlobalId,
            png: pngGlobalId
          }
        };
    } catch (error) {
      toast.error("Failed to upload signature files");
      return;
    }
  }

  return template;
};
